export default __webpack_public_path__ + "static/media/head_red.a8d76969.png";